import PBService from "@irati/utils/services"
import client, {QueryOptions} from "@irati/utils/services/apollo"
import {getSupportedLocale} from "@irati/utils/lang"
import getDeviceLocale from "@irati/utils/lang/helpers/getDeviceLocale"

import loginErrorHandler from "./errors/legacy/loginErrorHandler"
import globalLoginQuery from "./queries/globalLogin"

class GlobalLoginService extends PBService {
  forgotSubdomain(email: string, options: QueryOptions = {}) {
    const variables = {email, locale: getSupportedLocale(getDeviceLocale())}
    return client
      .query({fetchPolicy: "network-only", ...options, query: globalLoginQuery, variables})
      .catch(() => {
        /** no-op */
      })
      .then(() => true)
  }
}

const service = new GlobalLoginService({errorHandlers: [loginErrorHandler]})

export default service
